import { EventSpaceZone } from "./guests/event-space-zone.model";

export interface SpaceZoneFilterValue {
  spaceId?: number | null;
  zoneId?: number | null;
  placeKey?: string | null;
}

export interface ZonePlaceOption {
  key: string;
  label: string;
}

export interface SpaceOption {
  id: number | null;
  name: string;
}

export type ZonePlacesMap = Record<string, ZonePlaceOption[]>;

export interface ZoneFilterMetadata {
  spaces: SpaceOption[];
  zones: EventSpaceZone[];
  zonePlacesMap: ZonePlacesMap;
  spacePlaceholder?: string;
  zonePlaceholder?: string;
  placePlaceholder?: string;
}

export const NO_ZONE_KEY = "__NO_ZONE__";

export const buildZonePlacesKey = (zoneId: number | null | undefined): string =>
  zoneId === null || zoneId === undefined ? NO_ZONE_KEY : String(zoneId);

export const buildZonePlaceKey = (
  zoneId: number | null | undefined,
  file?: string | null,
  position?: string | null
): string | null => {
  if ((file == null || file === "") && (position == null || position === "")) {
    return null;
  }

  const normalizedFile = (file ?? "").trim();
  const normalizedPosition = (position ?? "").trim();

  return `${buildZonePlacesKey(zoneId)}::${normalizedFile}::${normalizedPosition}`;
};
